import { create } from 'zustand';

type PageSource = 'widget' | 'playground' | 'share';

export const DEFAULT_CANVAS_TITLE = 'Canvas';

interface ChatStoreStatus {
  pageSource: PageSource | undefined;
  setPageSource: (pageSource: PageSource) => void;

  // 需要展示的消息 Canvas
  // PC 端因为是弹框的交互，同时只能存在一个
  // 移动端是嵌入在消息的下面，同时可以打开多个 Canvas
  shownCanvas: {
    [messageId: string]: {
      url: string;
      title: string;
    };
  };
  addShownCanvas: (messageId: string, url: string, title: string) => void;
  removeShownCanvas: (messageId: string) => void;
  // 覆盖性设置 Canvas
  setShownCanvas: (messageId: string, url: string, title: string) => void;
  clearShownCanvas: () => void;

  ttsMuted: boolean;
  setTtsMuted: (ttsMuted: boolean) => void;
}

export const useChatStore = create<ChatStoreStatus>((set) => ({
  pageSource: undefined,
  shownCanvas: {},
  setPageSource: (pageSource) => set({ pageSource }),
  addShownCanvas: (messageId: string, url: string, title: string) => {
    set((state) => ({ shownCanvas: { ...state.shownCanvas, [messageId]: { url, title } } }));
  },
  removeShownCanvas: (messageId: string) => {
    set((state) => ({
      shownCanvas: Object.fromEntries(Object.entries(state.shownCanvas).filter(([key]) => key !== messageId)),
    }));
  },
  setShownCanvas: (messageId: string, url: string, title: string) => {
    set(() => ({ shownCanvas: { [messageId]: { url, title } } }));
  },
  clearShownCanvas: () => {
    set({ shownCanvas: {} });
  },
  ttsMuted: false,
  setTtsMuted: (ttsMuted: boolean) => {
    set({ ttsMuted });
  },
}));
